import bffAPI from 'services/api/bff';
import { getFilterURLParamsString } from 'utils/filter';

export async function getBrandsByCategory(categorySlug, params) {
  if (typeof categorySlug !== 'string') {
    throw new SyntaxError(`'categorySlug' must be of type 'string'. '${categorySlug}' provided.`);
  } else if (categorySlug === '') {
    throw new SyntaxError(`'categorySlug' param is required 'string'.`);
  }

  const paramsString = getFilterURLParamsString({ category: categorySlug, ...params }, true);
  return bffAPI.get(`/brands?${paramsString}`).then(({ data }) => data);
}

export async function getBrands(params) {
  const paramsString = getFilterURLParamsString(params, true);
  return bffAPI.get(`/brands?${paramsString}`).then(({ data }) => data);
}
